export namespace Icons {
    export enum Arrows {
        down = 'arrow-down',
        left = 'arrow-left',
        right = 'arrow-right',
        up = 'arrow-up'
    }
    export enum Alerts {
        bell = 'bell',
        triangle_exclamation = 'triangle-exclamation',
        circle_check = 'circle-check',
        circle_exclamation = 'circle-exclamation',
        circle_info = 'circle-info',
        circle_question = 'circle-question',
        circle_xmark = 'circle-xmark'
    }
    export enum Charts {
        area = 'chart-area',
        column = 'chart-column',
        line = 'chart-line',
        simple = 'chart-simple',
        pie = 'chart-pie',
        diagram_project = 'diagram-project',
        table = 'table-columns',
        table_cells = 'table-cells',
        table_list = 'table-list'
    }
    export enum Chevrons {
        down = 'chevron-down',
        left = 'chevron-left',
        right = 'chevron-right',
        up = 'chevron-up',
        circle_up = 'circle-chevron-up',
        circle_down = 'circle-chevron-down'
    }
    export enum Money {
        dollar = 'dollar-sign',
        euro = 'euro-sign',
        sterling = 'sterling-sign',
        cart = 'cart-shopping',
        credit_card = 'credit-card',
        hand_holding_dollar = 'hand-holding-dollar',
        hand_holding_heart = 'hand-holding-heart',
        bill = 'money-bill',
        check = 'money-check',
        piggy_bank = 'piggy-bank',
        dollar_to_slot = 'circle-dollar-to-slot',
        transfer = 'money-bill-transfer',
        wallet = 'wallet-solid',
        landmark = 'landmark',
        gavel = 'gavel-solid',
        percent = 'percent',
        SRI = 'SRI',
        coins = 'coins'
    }
    export enum Navigation {
        bars = 'bars',
        side_bar = 'side-bar',
        magnifying_glass = 'magnifying-glass',
        rotate_left = 'rotate-left',
        repeat = 'repeat',
        list = 'list',
        list_check = 'list-check',
        arrow_up_right_from_square = 'arrow-up-right-from-square',
        house = 'house',
        sort = 'sort',
        sort_up = 'sort-up',
        sort_down = 'sort-down',
        ellipsis = 'ellipsis',
        ellipsis_vertical = 'ellipsis-vertical',
        location_dot = 'location-dot',
        location_pin = 'location-pin'
    }
    export enum Actions {
        xmark = 'xmark',
        check = 'check',
        question = 'question',
        minus = 'minus',
        plus = 'plus',
        eye_slash = 'eye-slash',
        eye = 'eye',
        arrow_right_arrow_left = 'arrow-right-arrow-left-solid',
        gear = 'gear',
        eraser = 'eraser',
        sliders = 'sliders',
        filter = 'filter',
        thumbtack = 'thumbtack',
        trash = 'trash',
        delete_left = 'delete-left',
        right_from_bracket = 'right-from-bracket',
        right_to_bracket = 'right-to-bracket',
        square = 'square',
        square_check = 'square-check',
        play = 'play',
        download = 'arrow-down-to-line',
        check_mark = 'check-mark'
    }
    export enum Communication {
        plane = 'paper-plane',
        envelope = 'envelope',
        envelope_open = 'envelope-open-solid',
        comment = 'comment',
        message = 'message',
        pen_to_square = 'pen-to-square-solid',
        pen = 'pen',
        at = 'at',
        video = 'video',
        headset = 'headset',
        headphones = 'headphones',
        phone = 'phone',
        cookie = 'cookie-solid',
        reply_all = 'reply-all-solid',
        reply = 'reply-solid',
        share = 'share-solid',
        quote_left = 'quote-left',
        quote_right = 'quote-right',
        pencil = 'pencil-solid',
        globe = 'globe'
    }
    export enum Files {
        folder = 'folder',
        briefcase = 'briefcase',
        archive_box = 'box-archive',
        address_book = 'address-book',
        clipboard_list = 'clipboard-list',
        file_import = 'file-import',
        book = 'book',
        clipboard = 'clipboard',
        folder_plus = 'folder-plus',
        newspaper = 'newspaper',
        paperclip = 'paperclip',
        file = 'file-solid',
        file_lines = 'file-lines-solid'
    }
    export enum Social {
        netwealth = 'netwealth',
        facebook = 'facebook',
        x = 'x-twitter',
        instagram = 'instagram',
        linkedin = 'linkedin',
        youtube = 'youtube',
        star = 'star'
    }
    export enum Time {
        calendar = 'calendar-days',
        clock = 'clock',
        history = 'clock-rotate-left-solid',
        timeline = 'timeline'
    }
    export enum People {
        circle_user = 'circle-user',
        user = 'user',
        group = 'user-group-solid',
        children = 'children-solid',
        shield = 'user-shield-solid',
        hand = 'hand',
        handshake = 'handshake-angle-solid',
        fingerprint = 'fingerprint'
    }
    export enum Miscellaneous {
        link = 'link',
        link_slashed = 'link-slashed',
        bolt = 'bolt',
        crown = 'crown',
        gem = 'gem',
        dot = 'dot',
        circle = 'circle',
        bullseye = 'bullseye',
        wrench = 'wrench'
    }
    export enum Security {
        shield = 'shield-halved-solid',
        locked = 'lock-solid',
        unlocked = 'unlock-solid'
    }
    export enum Banks {
        barclays = 'barclays',
        halifax = 'halifax',
        hsbc = 'hsbc',
        national_westminster_bank = 'natwest',
        lloyds = 'lloyds',
        bank_of_scotland = 'bank-of-scotland',
        royal_bank_of_scotland = 'royal-bank-of-scotland',
        tsb = 'tsb',
        santander = 'santander',
        bank_of_ireland = 'bank-of-ireland',
        standard_chartered = 'standard-chartered',
        monzo = 'monzo',
        danske_bank = 'danske-bank',
        mbna = 'mbna',
        icbc = 'icbc',
        vanquis = 'vanquis',
        chase = 'chase',
        cooperative_bank = 'coop',
        c_hoare_and_co = 'c-hoare-co',
        hmrc = 'hmrc',
        bank_of_east_asia = 'bank-of-east-asia'
    }

    type _Type =
        | Alerts
        | Arrows
        | Charts
        | Chevrons
        | Money
        | Navigation
        | Actions
        | Communication
        | Files
        | Social
        | Time
        | People
        | Miscellaneous
        | Security
        | Banks;

    export type Type = `${_Type}`;

    export type PreserveAspectRatio =
        `xMinYMin` | `xMaxYMin` | `xMinYMax` | `xMaxYMax` | `xMidYMid`;

    export type ThirdParty = `http${string}`;
}

export const ICONS: Icons.Type[] = [
    ...Object.values(Icons.Alerts),
    ...Object.values(Icons.Arrows),
    ...Object.values(Icons.Charts),
    ...Object.values(Icons.Chevrons),
    ...Object.values(Icons.Money),
    ...Object.values(Icons.Navigation),
    ...Object.values(Icons.Actions),
    ...Object.values(Icons.Communication),
    ...Object.values(Icons.Files),
    ...Object.values(Icons.Social),
    ...Object.values(Icons.Time),
    ...Object.values(Icons.People),
    ...Object.values(Icons.Miscellaneous),
    ...Object.values(Icons.Security),
    ...Object.values(Icons.Banks)
];
